import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { createStore, applyMiddleware, combineReducers } from 'redux'
import { Provider } from 'react-redux'
import reduxThunk from 'redux-thunk'
import promise from 'redux-promise'
import { reducer as form } from 'redux-form'
import injectTapEventPlugin from 'react-tap-event-plugin'
import { MuiThemeProvider as MuiThemeProviderOld } from 'material-ui-effco/styles'
import { MuiThemeProvider } from 'material-ui/styles'
import core from './core'
import App from './App'
// import registerServiceWorker from './registerServiceWorker'
import './index.css'

injectTapEventPlugin()

const createStoreWithMiddleware = applyMiddleware(promise, reduxThunk)(
  createStore
)
const store = createStoreWithMiddleware(
  combineReducers({ form }),
  window.devToolsExtension ? window.devToolsExtension() : f => f
)

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProviderOld muiTheme={core.constants.oldTheme}>
      <MuiThemeProvider theme={core.constants.newTheme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MuiThemeProvider>
    </MuiThemeProviderOld>
  </Provider>,
  document.getElementById('root')
)
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js